import Typography from '@/common/components/base/typography/Typography';
import { TypographyType } from '@/common/components/base/typography/Typography.type';
import { Center, Flex } from 'styled-system/jsx';
import RialIcon from '../../assets/icons/walletRial.svg?react';

export default function RialAmount({
  amount,
  color = 'black',
  iconBoxSize = 16,
  gap = 4,
  textProps,
}: {
  amount: number | string;
  color?: TypographyType['color'];
  iconBoxSize?: number;
  gap?: number;
  textProps?: TypographyType;
}) {
  const numAmount = Number(amount);

  return (
    <Flex
      alignItems={'center'}
      gap={gap}
      color={color}
      css={{ '& svg path': { fill: 'currentColor' } }}
    >
      <Typography
        fontSize={18}
        lineHeight={'24px'}
        color={'inherit'}
        {...textProps}
      >
        {isNaN(numAmount) ? '--' : numAmount.toLocaleString('en-US')}
      </Typography>
      <Center width={iconBoxSize} height={iconBoxSize} flexShrink={0}>
        <RialIcon />
      </Center>
    </Flex>
  );
}
